import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    cursor: 'pointer',
    fontSize: theme.size.sm,
    color: theme.palette.textAlt,
    marginBottom: '0.25rem'
  },

  icon: {
    cursor: 'pointer',
    marginLeft: '7px',
    height: 'auto',
    width: '10px',
    opacity: '0.7'
  }
}))

export default useStyles
